<app-navigation-panel></app-navigation-panel>

<div class="content">
  <router-outlet></router-outlet>
</div>
